<button
  class="card-btn"
  [ngClass]="{ 'card-btn--inverted': this.inverted }"
  type="{{ buttonType }}"
  [disabled]="buttonDisabled"
  (click)="onClick()"
>
  {{ buttonLabel }}
</button>
